const getPercentageRequired = content => {
  var _quizCTASection$passM;
  const quizCTASection = content.sections.find(item => item.sectionName === "quiz-cta");
  const totalQuestions = content.sections.filter(item => item.sectionName.includes("mc-quiz-question")).length;
  const passMark = (_quizCTASection$passM = quizCTASection.passMark) !== null && _quizCTASection$passM !== void 0 ? _quizCTASection$passM : totalQuestions;
  const percentageRequired = passMark / totalQuestions * 100;
  return percentageRequired;
};
export const showNoAttemptsLeft = (content, quizState) => {
  const percentageRequired = getPercentageRequired(content);
  return (quizState === null || quizState === void 0 ? void 0 : quizState.quizAttemptsLeft) === 0 && (quizState === null || quizState === void 0 ? void 0 : quizState.latestQuizScore) < percentageRequired;
};
export const INITIAL_QUIZ_STATE = {
  quizResult: null,
  precentReceived: null,
  loading: false,
  tryAgain: null,
  //does what?
  quizAttemptsLeft: -1,
  latestQuizScore: null,
  forwardToActive: false
};
export const UPDATE_QUIZ = "update-quiz";
export const FINISH_QUIZ = "finish-quiz";
export const LOADING = "loading-quiz";
export const TRY_AGAIN = "try-again-quiz";
export const CLOSE_QUIZ = "close-quiz";
export const quizReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_QUIZ:
      {
        return {
          ...state,
          ...action.payload
        };
      }
    case TRY_AGAIN:
      {
        return {
          ...INITIAL_QUIZ_STATE,
          tryAgain: true
        };
      }
    case CLOSE_QUIZ:
      {
        return {
          ...INITIAL_QUIZ_STATE,
          forwardToActive: true
        };
      }
    case FINISH_QUIZ:
      {
        const {
          quizResult,
          quizAttemptsLeft,
          latestQuizScore
        } = action.payload;
        let newState = {
          ...state,
          quizResult,
          quizAttemptsLeft,
          latestQuizScore
        };
        if (quizResult === "fail") {
          newState = {
            ...newState,
            // ...INITIAL_QUIZ_STATE,
            // quizResult: null,
            forwardToActive: false,
            tryAgain: true
          };
        }
        return newState;
      }
    case LOADING:
      {
        return {
          ...state,
          loading: true
        };
      }
    default:
      throw new Error("Unsupported quiz reducer action type");
  }
};